var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "mdi-currency-usd",
                  label: "Filter transactions"
                },
                model: {
                  value: _vm.filter,
                  callback: function($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("RangePicker", {
                attrs: { range: this.getDefaultWeek() },
                on: { reloadData: _vm.loadData }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-data-table",
        {
          attrs: {
            search: _vm.filter,
            "items-per-page": -1,
            headers: _vm.headers,
            items: _vm.transactions,
            "item-key": "id"
          },
          on: { "current-items": _vm.getFiltered },
          scopedSlots: _vm._u([
            {
              key: "item.amend",
              fn: function(ref) {
                var item = ref.item
                return [
                  _vm.checkGate("void-transaction")
                    ? _c(
                        "v-container",
                        { staticClass: "controls" },
                        [
                          item.status === "paid"
                            ? _c(
                                "div",
                                { staticClass: "v-text-field" },
                                [
                                  item.category != "split" &&
                                  item.category != "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "red--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.voidItem(item)
                                            }
                                          }
                                        },
                                        [
                                          item.method == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-refund")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-refund")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.category == "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "red--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.refund(item)
                                            }
                                          }
                                        },
                                        [
                                          item.method == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-refund")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-refund")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : item.status != "paid"
                            ? _c(
                                "div",
                                { staticClass: "v-text-field" },
                                [
                                  item.category != "split" &&
                                  item.category != "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "green--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.undoVoidItem(item)
                                            }
                                          }
                                        },
                                        [
                                          item.method == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-plus")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-plus")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.category == "pckg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "green--text",
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.undoRefund(item)
                                            }
                                          }
                                        },
                                        [
                                          item.method == "CC"
                                            ? _c("v-icon", [
                                                _vm._v("mdi-credit-card-plus")
                                              ])
                                            : _c("v-icon", [
                                                _vm._v("mdi-cash-plus")
                                              ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.paymentMethods(item),
                              width: "30px",
                              loading: _vm.savingPaymentMethod
                            },
                            on: {
                              change: function($event) {
                                return _vm.changePaymentMethod(item)
                              }
                            },
                            model: {
                              value: item.method,
                              callback: function($$v) {
                                _vm.$set(item, "method", $$v)
                              },
                              expression: "item.method"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            },
            {
              key: "item.price",
              fn: function(ref) {
                var item = ref.item
                return [
                  item.status == "refunded"
                    ? _c("span", [
                        _vm._v("$" + _vm._s(-Math.abs(item.price)) + " ")
                      ])
                    : _c("span", [_vm._v("$" + _vm._s(item.price) + " ")])
                ]
              }
            },
            {
              key: "item.created_at",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        new Date(item.created_at).toLocaleString("en-AU", {
                          timeZone: "UTC",
                          weekday: "short",
                          year: "numeric",
                          month: "short",
                          day: "numeric"
                        })
                      )
                    )
                  ])
                ]
              }
            },
            {
              key: "item.notes",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("ul", [
                    item.notes
                      ? _c("li", [_vm._v(_vm._s(item.notes))])
                      : _vm._e(),
                    _vm._v(" "),
                    item.loadNotes
                      ? _c("li", [
                          _c("small", [_vm._v("load Notes: ")]),
                          _vm._v(_vm._s(item.loadNotes))
                        ])
                      : _vm._e()
                  ])
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _c("template", { slot: "body.append" }, [
            _c("tr", { staticClass: "pink--text" }, [
              _c("th", { staticClass: "title" }, [_vm._v("Total")]),
              _vm._v(" "),
              _c("th", { staticClass: "title" }, [
                _vm._v("$" + _vm._s(_vm.total))
              ])
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }